/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Invalidate API key request
 */
export interface InvalidateApiKeyRequest {
  /**
   * Main account or subaccount ID. Main account is used if not set
   */
  accountId?: number;
  /**
   * API key ID
   */
  keyId: number;
}
